<div class="form-group" [ngClass]="{ required: markAsRequired, valid: markAsValid, invalid: isInvalid(control) }">
	<label class="col-form-label" [for]="id">{{ label }}</label>
	<div class="input-field">
		<div #inputSelect class="form-input-select" [ngClass]="{ 'is-disabled': disabled, touched: control.dirty }">
			<select
				class="form-control"
				[ngClass]="{ 'is-invalid': isInvalid(control) }"
				[id]="id"
				[formControl]="control"
				tabIndex="{{ tabIndex }}"
			>
				<option *ngFor="let option of options$ | async" [value]="option.id" [label]="option.label"></option>
			</select>
		</div>
		<div *ngIf="isInvalid(control)" class="invalid-feedback d-block">
			<small *ngIf="inputErrors(control, 'required')">
				<span>{{ 'error.required' | translate: { fieldName: label ? label : placeholder } }}</span>
			</small>
			<small *ngIf="inputErrors(control, 'invalidCountry')">
				<span>{{ 'inputText.error.invalidCountry' | translate }}</span>
			</small>
		</div>
	</div>
</div>
